<template>
    <section class="a-op-polls">
        <h2 class="a-op-polls__title">
            {{ pollsData.title }}
        </h2>
        <div class="a-op-polls__container">
            <div class="a-op-polls__wrapper">
                <p class="a-op-polls__desc">
                    {{ pollsData.desc }}
                </p>
                <div
                    v-for="(chart, i) in pollsData.charts"
                    :key="i"
                    class="a-op-polls__chart-wrap">
                    <span class="a-op-polls__sub">
                        {{ chart.title }}
                    </span>
                    <div class="a-op-polls__chart">
                        <span  v-for="(value, k) in chart.values"
                               :key="k"
                            :style="value <= 1
                            ?
                            {
                                flexGrow: 1,
                                backgroundColor: pollsData.colors[k].color,
                                width: '.524rem'
                            }
                            : {
                                flexGrow: value,
                                backgroundColor: pollsData.colors[k].color
                            }">
                            {{ value }}
                        </span>
                    </div>
                </div>
                <div class="a-op-polls__labeles">
                    <div
                        v-for="(color, i) in pollsData.colors"
                        :key="i"
                        class="a-op-polls__label">
                        <span :style="{backgroundColor: color.color}"></span>
                        <span>{{ color.text }}</span>
                    </div>
                </div>
            </div>
            <div class="a-op-polls__wrapper">
                <div
                    v-for="(item, i) in pollsData.items"
                    :key="i"
                    class="a-op-polls__item">
                    <span class="a-op-polls__share">
                        {{ item.value }}
                    </span>
                    <span class="a-op-polls__text">
                        {{ item.title }}
                    </span>
                </div>
                <p class="a-op-polls__conclusion">
                    {{ pollsData.conclusion }}
                </p>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'Polls',
        props: {
          pollsData: Object
        },
        data() {
            return {
                title: 'Оценка деловой активности застройщиков жилья',
                desc: 'Вывод на рынок новых проектов, %',
                charts: [
                    {
                        date: 'План на апрель 2023',
                        up: 0,
                        same: 80,
                        down: 20,
                    },
                    {
                        date: 'План на май 2023',
                        up: 3,
                        same: 75,
                        down: 22,
                    }
                ],
                items: [
                    {
                        share: '62%',
                        text: 'девелоперов выполнили план по продажам (-4 п.п. за месяц)'
                    },
                    {
                        share: '96%',
                        text: 'застройщиков отметили рост или сохранение доступности проектного финансирования по текущим проектам (-1 п.п. за месяц)',
                    }
                ],
                colors: [
                    {
                        color: '#67A511',
                        text: 'перевыполнен'
                    },
                    {
                        color: '#A3D562',
                        text: 'выполнен'
                    },
                    {
                        color: '#9AC2FF',
                        text: 'не выполнен'
                    },
                ],
                conclusion: 'Ключевые показатели деловой активности застройщиков'
            }
        }
    }
</script>